/*
Duplicate file server/booking-selecting-staff-options.js
*/
export default {
  staffOrNoPreference: {
    name: 'Customers can select a staff member, or choose no preference (default)',
    option: 'staffOrNoPreference',
  },
  specifiedStaff: {
    name: 'Customers must select a specific staff member',
    option: 'specifiedStaff',
  },
  autoAssigned: {
    name: 'Have no option to select staff, staff automatically assigned',
    option: 'autoAssigned',
  },
};
